import { HttpClient } from "@angular/common/http";
import { Injectable, InjectionToken, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { OAuthStorageAdapter } from "@impacgroup/angular-oauth-base";
import { ApiListQueryParameter, BaseDatatableStateSaveMode } from "@impacgroup/angular-baselib";
import { map } from "rxjs/operators";
import { classToPlain, plainToClass } from "class-transformer";
import { SalesManagerShopItem } from "../../api-models/SalesManagerShopItem";

export interface ISalesManagerShopItemConfigService {
    salesManagerShopItemsAPI: string;
    utcDateFormat: string;
    datatableStateSaveMode: BaseDatatableStateSaveMode;
}

export const SalesManagerShopItemConfigService = new InjectionToken<ISalesManagerShopItemConfigService>("SalesManagerShopItemConfig");

@Injectable()
export class SalesManagerShopItemsService {
    public UTCDATEFORMAT: string = "";
    public datatableStateSaveMode: BaseDatatableStateSaveMode;

    constructor(
        @Inject(SalesManagerShopItemConfigService) private salesManagerShopItemConfig: ISalesManagerShopItemConfigService,
        private http: HttpClient,
        private oauthStorageAdapter: OAuthStorageAdapter
    ) {
        this.UTCDATEFORMAT = this.salesManagerShopItemConfig.utcDateFormat;
        this.datatableStateSaveMode = this.salesManagerShopItemConfig.datatableStateSaveMode;
    }

    public list(params: ApiListQueryParameter): Observable<{ list: SalesManagerShopItem[]; count: number; total: number }> {
        return this.http
            .get<any>(this.getSalesManagerShopItemsServiceUrl(""), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON(),
                params: params as any,
                observe: "response"
            })
            .pipe(
                map((result) => {
                    let count = result.body.length;
                    let total = result.body.length;
                    try {
                        count = parseInt(result.headers.get("X-Pagination-Count"), 10);
                    } catch (e) {}
                    try {
                        total = parseInt(result.headers.get("X-Total-Count"), 10);
                    } catch (e) {}

                    return {
                        list: plainToClass(SalesManagerShopItem, result.body as any[]),
                        count: count,
                        total: total
                    };
                })
            );
    }

    public salesManagerShopItemDetail(id: string): Observable<SalesManagerShopItem> {
        return this.http
            .get<Object>(this.getSalesManagerShopItemsServiceUrl(id), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToClass(SalesManagerShopItem, result)));
    }

    public addSalesManagerShopItem(salesManagerShopItem: SalesManagerShopItem): Observable<SalesManagerShopItem> {
        return this.http
            .post<Object>(this.getSalesManagerShopItemsServiceUrl(""), classToPlain(salesManagerShopItem), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToClass(SalesManagerShopItem, result)));
    }

    public updateSalesManagerShopItem(salesManagerShopItem: SalesManagerShopItem): Observable<SalesManagerShopItem> {
        return this.http
            .patch<Object>(this.getSalesManagerShopItemsServiceUrl(salesManagerShopItem._id), classToPlain(salesManagerShopItem), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToClass(SalesManagerShopItem, result)));
    }

    public deleteSalesManagerShopItem(id: string): Observable<SalesManagerShopItem> {
        return this.http
            .delete<Object>(this.getSalesManagerShopItemsServiceUrl(id), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToClass(SalesManagerShopItem, result)));
    }

    private getSalesManagerShopItemsServiceUrl(postfix: string): string {
        return this.salesManagerShopItemConfig.salesManagerShopItemsAPI + postfix;
    }
}
